import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=4a210dee&scoped=true&"
import script from "./invoice-list.vue?vue&type=script&lang=js&"
export * from "./invoice-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a210dee",
  null
  
)

export default component.exports